import { EventMeta } from '../../../interfaces/meta.interface';

const hardDelete: EventMeta<any> = {
    title: 'Message Purged from Group Mailbox',
    default: {
        description: 'Message Purged from Group Mailbox',
        longDescription: 'A message was purged from the Recoverable Items folder (permanently deleted).',
        severity: 'info',
    },
};

export default hardDelete;
